import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';

@Injectable({
    providedIn: 'root',
})
export class AmplitudeService {
    initAmplitude() {
        amplitude.init('c66ac02aec3e948746df93f765cf9a05');
    }

    trackEvent(eventName: string, eventData?: any) {
        amplitude.track(eventName, eventData);
    }

    setUserId(userId: string) {
        amplitude.setUserId(userId);
    }
}